import "core-js/modules/es6.array.map";
import React from 'react';
import ListItem, { ListItemType } from './ListItem.component';
import bem from '../../_utils/bem';

var UnorderedList = function UnorderedList(_ref) {
  var _ref$block = _ref.block,
      block = _ref$block === void 0 ? 'ul' : _ref$block,
      _ref$element = _ref.element,
      element = _ref$element === void 0 ? 'item' : _ref$element,
      _ref$modifiers = _ref.modifiers,
      modifiers = _ref$modifiers === void 0 ? [] : _ref$modifiers,
      items = _ref.items;
  return /*#__PURE__*/React.createElement("ul", {
    className: bem(block, null, modifiers)
  }, items.map(function (_ref2, index) {
    var content = _ref2.content,
        label = _ref2.label;
    return /*#__PURE__*/React.createElement(ListItem, {
      key: index,
      block: block,
      element: element,
      modifiers: modifiers,
      label: label
    }, content);
  }));
};

export default UnorderedList;